<template>
  <div>
    <el-top-nav-menu-4
      :logo="logoBase"
      companyTitle="供方注册"
      :dashboard="baseUrl"
      :Menu4Href="true"
      width="1180px"
      ref="topNavMenu"
    >
    </el-top-nav-menu-4>
    <div class="registerBox">
      <el-steps
        class="steps"
        :space="180"
        :align-center="true"
        :active="active"
        finish-status="success"
      >
        <el-step
          :class="active === 0 ? 'currentStep' : ''"
          title="填写注册信息"
        ></el-step>
        <el-step
          :class="active === 1 ? 'currentStep' : ''"
          title="供方基本信息"
        ></el-step>
        <el-step
          :class="active === 2 ? 'currentStep' : ''"
          title="供方商财务信息"
        ></el-step>
      </el-steps>
      <div class="main">
        <firstStep
          v-if="active == 0"
          :extForm="registerForm.subconAuthAccountInfo"
          :subconChangeInfo="registerForm.subconChangeInfo"
          :registerForm="registerForm"
          @open="openDialog"
          @getStep="getStep"
        >
        </firstStep>
        <secondStep
          :extForm="registerForm"
          v-if="active == 1"
          @open="openDialog"
          @getStep="getStep"
        ></secondStep>
        <thirdStep
          v-if="active == 2"
          :thirdStepId="registerForm.subconChangeInfo.id"
          :extForm="registerForm.subconChangeInfo"
          :extTable="registerForm.subconTyPerChange"
          @open="openDialog"
          @getStep="getStep"
        ></thirdStep>
      </div>
    </div>
  </div>
</template>

<script>
import logoBase from "../../../../assets/images/logoS.png";
import firstStep from "./firstStep.vue";
import secondStep from "./secondStep.vue";
import thirdStep from "./thirdStep.vue";
import LOGO from "@/assets/images/logoS.png";
export default {
  components: {
    firstStep,
    secondStep,
    thirdStep,
    logoBase,
    LOGO,
  },
  data() {
    return {
      centerDialogVisible: false,
      firstItem: {},
      logoBase,
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_SHOPPAGE_URL),
      showInput: false,
      active: 0, //步骤条进度
      secondStepId: "",
      registerForm: {
        // 基础信息
        subconChangeInfo: {
          subconType: [],
          inputValue: "",
          legalPersonCardFront: "",
          yesNoCopy: "",
        },
        // 主要设备
        subconDeviceInfoChange: [],
        // 分包商专业
        subconSubjectChange: [],
        // 授权账号信息
        subconAuthAccountInfo: {
          // 姓名
          authUserName: "",
          // 手机号
          phone: "",
          // 密码
          password: "",
          // 二次确认密码
          secondaryPassword: "",
          // 供应商名称
          supplierName: "",
          // 信用代码
          unifiedCreditCode: "",
          // 合作单位
          cooUnitName: "",
          // 合作单位编码
          cooUnitCode: "",
          // 合作单位id
          cooUnitId: "",
          // 验证码
          verificationCode: "",
          cardType: "",
          registerEmail: "",
          authPersonIdCard: "",
          authCertificate: "",
        },
        // 资质列表
        subconQualificationsChange: [],
        // 主要管理人员
        subconManagePersonChange: [],
        // 财务信息
        subconTyPerChange: [],
        // 合作业绩
        subconCooPfeChange: [],
        // 其他信息
        subconExtInfoChange: [],
      },
    };
  },
  methods: {
    openDialog() {
      this.$message({
        showClose: true,
        message: "请完善信息",
        type: "warning",
      });
      // this.centerDialogVisible=true
    },
    localData(val) {
      this.secondStepInfo = val;
    },
    next() {
      if (this.active++ > 2) this.active = 0;
    },
    // firstStep(firstItem, val) {
    //   this.firstItem = firstItem;
    //   console.log(firstItem, "firstItem");
    //   this.active = val;
    // },
    getSecondStep(id) {
      this.secondStepId = id;
    },
    getStep(val, zzq) {
      this.active = val;
    },
  },
};
</script>

<style lang="scss">
.registerBox {
  margin-top: 30px !important;
  width: 1184px !important;
  display: flex;
  flex-direction: column;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
  .steps {
    height: 100px;
    width: 55%;
  }
  width: 100%;
  margin: 0 auto;
  padding: 40px 0;
  //   margin: 0 128px !important;
  background: #ffffff;
  border-radius: 2px;
  line-height: 22px;
  .el-steps .el-step {
    .el-step__head.is-success,
    .el-step__main el-step__title is-success {
      color: #ff152e;
      border-color: #ff152e;
    }
    .el-step__icon {
      width: 32px;
      height: 32px;
      .el-step__icon-inner {
        font-size: 20px;
      }
    }
    .el-step__title,
    .el-step__title.is-success {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ff152e;
    }
    .el-step__title {
      color: rgba(0, 0, 0, 0.45);
    }
    .el-step__title is-success,
    .el-step__title is-process {
      color: #ff152e;
    }
    .el-step__line {
      width: 70%;
      margin: 0 15%;
      background: rgba(0, 0, 0, 0.15);
    }
    .el-step__title.is-success {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff152e;
    }
  }
  .currentStep {
    .el-step__head .el-step__icon {
      background: #ff152e;
      border: none;
      color: white;
      font-size: 16px;
    }
  }
}
.main {
  width: 100%;
}
</style>
